import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MyAccount } from './components/my-account/MyAccount';
import { ProductFinder } from './components/product-finder/ProductFinder';
import { DailyPortionTool } from './components/daily-portion-tool/DailyPortionTool';
import { Home } from './components/home/Home';
import React from "react";

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}>
        <Route path="us/product-finder/*" element={<ProductFinder />} />
        <Route path="us/daily-portion-tool/*" element={<DailyPortionTool />} />
        <Route path="us/my-account/*" element={<MyAccount />} />
        <Route path="us/home" element={<Home />} />
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  </BrowserRouter>
);
